import { useEffect } from 'react';
import { IWebsiteAnalyticCredential, WebsiteAnalyticCredentialType } from '@/entities';

interface IWebsiteAnalyticsProps {
  analyticCredentials?: IWebsiteAnalyticCredential[];
}

export const WebsiteAnalytics = ({ analyticCredentials = [] }: IWebsiteAnalyticsProps) => {
  const FACEBOOK_PIXEL_ID = analyticCredentials.find((item) => {
    return item.type === WebsiteAnalyticCredentialType.META_PIXEL;
  })?.apiKey;

  const GOOGLE_ANALYTICS_ID = analyticCredentials.find((item) => {
    return item.type === WebsiteAnalyticCredentialType.GOOGLE_ANALYTICS;
  })?.apiKey;

  const GOOGLE_TAG_MANAGER_ID = analyticCredentials.find((item) => {
    return item.type === WebsiteAnalyticCredentialType.GOOGLE_TAG_MANAGER;
  })?.apiKey;

  const TIKTOK_PIXEL_ID = analyticCredentials.find((item) => {
    return item.type === WebsiteAnalyticCredentialType.TIKTOK_PIXEL;
  })?.apiKey;

  useEffect(() => {
    if (GOOGLE_ANALYTICS_ID) {
      window.dataLayer = window.dataLayer || [];
      // eslint-disable-next-line no-inner-declarations
      function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      }
      // @ts-ignore
      gtag('js', new Date());
      // @ts-ignore
      gtag('config', GOOGLE_ANALYTICS_ID);

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
      document.head.appendChild(script);
      return () => {
        document.head.removeChild(script);
      };
    }

    return () => {};
  }, [GOOGLE_ANALYTICS_ID]);

  useEffect(() => {
    if (GOOGLE_TAG_MANAGER_ID) {
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');
      `;
      document.head.appendChild(gtmScript);
      return () => {
        document.head.removeChild(gtmScript);
      };
    }

    return () => {};
  }, [GOOGLE_TAG_MANAGER_ID]);

  useEffect(() => {
    if (FACEBOOK_PIXEL_ID) {
      const fbScript = document.createElement('script');
      fbScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${FACEBOOK_PIXEL_ID}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(fbScript);
      return () => {
        document.head.removeChild(fbScript);
      };
    }

    return () => {};
  }, [FACEBOOK_PIXEL_ID]);

  useEffect(() => {
    if (TIKTOK_PIXEL_ID) {
      const ttScript = document.createElement('script');
      ttScript.innerHTML = `
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
          ttq.methods=["track","identify","convert","pixel"];
          ttq.setAndDefer=function(t,n){ttq[t]=function(){ttq.push([t].concat(Array.prototype.slice.call(arguments,0)))};
          for(var i=0;i<n.length;i++)ttq.setAndDefer(n[i],["track","identify","convert","pixel"])}
          ttq.setAndDefer("config", ["page"]);
          ttq.load = function (e) { var n = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._v = "2.0";
          ttq.config(e);
          var i = document.createElement("script");
          i.type = "text/javascript";
          i.async = !0;
          i.src = n;
          var o = document.getElementsByTagName("script")[0];
          o.parentNode.insertBefore(i, o);};
          ttq.load('${TIKTOK_PIXEL_ID}');
        }(window, document, 'ttq');
      `;
      document.head.appendChild(ttScript);
      return () => {
        document.head.removeChild(ttScript);
      };
    }

    return () => {};
  }, [TIKTOK_PIXEL_ID]);

  return null;
};
